/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getRegimen } from 'app/entities/regimen/regimen.reducer';
import { createEntity, getEntity, reset, updateEntity } from './regimen-cycle.reducer';

export const RegimenCycleUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const regimen = useAppSelector(state => state.regimen.entities);
  const regimenCycleEntity = useAppSelector(state => state.regimenCycle.entity);
  const loading = useAppSelector(state => state.regimenCycle.loading);
  const updating = useAppSelector(state => state.regimenCycle.updating);
  const updateSuccess = useAppSelector(state => state.regimenCycle.updateSuccess);

  const handleClose = () => {
    navigate(`/regimen-cycle${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
    dispatch(getRegimen({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cycleNumber !== undefined && typeof values.cycleNumber !== 'number') {
      values.cycleNumber = Number(values.cycleNumber);
    }
    if (values.duration !== undefined && typeof values.duration !== 'number') {
      values.duration = Number(values.duration);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...regimenCycleEntity,
      ...values,
      treatmentType: clinicalDictionaries.find(it => it.id.toString() === values.treatmentType?.toString()),
      regimen: regimen.find(it => it.id.toString() === values.regimen?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...regimenCycleEntity,
          treatmentType: regimenCycleEntity?.treatmentType?.id,
          regimen: regimenCycleEntity?.regimen?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.regimenCycle.home.createOrEditLabel" data-cy="RegimenCycleCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.regimenCycle.home.createOrEditLabel">Create or edit a RegimenCycle</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="regimen-cycle-id"
                  label={translate('tinyMedicRestApp.regimenCycle.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenCycle.name')}
                id="regimen-cycle-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenCycle.description')}
                id="regimen-cycle-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenCycle.cycleNumber')}
                id="regimen-cycle-cycleNumber"
                name="cycleNumber"
                data-cy="cycleNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenCycle.duration')}
                id="regimen-cycle-duration"
                name="duration"
                data-cy="duration"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenCycle.durationUnit')}
                id="regimen-cycle-durationUnit"
                name="durationUnit"
                data-cy="durationUnit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenCycle.frequency')}
                id="regimen-cycle-frequency"
                name="frequency"
                data-cy="frequency"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenCycle.active')}
                id="regimen-cycle-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenCycle.cursor')}
                id="regimen-cycle-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenCycle.lastUpdated')}
                id="regimen-cycle-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenCycle.microSec')}
                id="regimen-cycle-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenCycle.timestampEntry')}
                id="regimen-cycle-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="regimen-cycle-treatmentType"
                name="treatmentType"
                data-cy="treatmentType"
                label={translate('tinyMedicRestApp.regimenCycle.treatmentType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-cycle-regimen"
                name="regimen"
                data-cy="regimen"
                label={translate('tinyMedicRestApp.regimenCycle.regimen')}
                type="select"
              >
                <option value="" key="0" />
                {regimen
                  ? regimen.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/regimen-cycle" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RegimenCycleUpdate;
